import ReactGA from "react-ga4";

const ENABLED = !!process.env.PUBLIC_GA_MEASUREMENT_ID;

export type TrackPlayTrigger = "manual" | "auto";

export function trackPlayStarted(params: {
  title: string;
  index: number;
  trigger: TrackPlayTrigger;
}): void {
  if (!ENABLED) return;
  ReactGA.event("track_play_started", {
    track_title: params.title,
    track_index: params.index,
    trigger: params.trigger,
  });
}

export function trackPlayed(params: { title: string; index: number }): void {
  if (!ENABLED) return;
  ReactGA.event("track_played", {
    track_title: params.title,
    track_index: params.index,
  });
}
